
(function() {
  const initTabs = () => {
    const wrappers = document.querySelectorAll('.tab-wrapper');
    
    wrappers.forEach(wrapper => {
      const links = wrapper.querySelectorAll('ul.tabs a');
      const panels = wrapper.querySelectorAll('.tab-panel');

      // CORE FUNCTION: Switches the UI
      const switchTab = (targetUrl, updateHistory = true) => {
        // Find link by data-url or handleized href
        const activeLink = Array.from(links).find(link => 
          link.getAttribute('data-url') === targetUrl || 
          link.getAttribute('href').replace('#', '') === targetUrl
        ) || links[0];

        const targetId = activeLink.getAttribute('href').replace('#', '');
        const targetPanel = wrapper.querySelector(`#${CSS.escape(targetId)}`);

        if (!targetPanel) return;

        // Update UI classes
        links.forEach(l => l.classList.remove('active'));
        panels.forEach(p => p.classList.remove('is-active'));

        activeLink.classList.add('active');
        targetPanel.classList.add('is-active');

        // Update URL and History
        if (updateHistory) {
          const newHash = `#/${targetUrl}`;
          // Use pushState so the back button records the change
          history.pushState({ tabUrl: targetUrl }, '', newHash);
        }

        // Re-calculate Shopify sliders (Crucial for Lighthouse/CLS)
        window.dispatchEvent(new Event('resize'));
      };

      // 1. CLICK HANDLING
      wrapper.querySelector('ul.tabs').addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (!link) return;
        e.preventDefault();
        
        const urlValue = link.getAttribute('data-url') || link.getAttribute('href').replace('#', '');
        switchTab(urlValue, true);
      });

      // 2. BACK/FORWARD BUTTON HANDLING (The fix for your issue)
      window.addEventListener('popstate', (event) => {
        const hash = window.location.hash.replace('#/', '').replace('#', '');
        if (hash) {
          switchTab(hash, false); // false = don't create a new history entry
        } else {
          // If no hash, go to the first tab (default state)
          const firstUrl = links[0].getAttribute('data-url') || links[0].getAttribute('href').replace('#', '');
          switchTab(firstUrl, false);
        }
      });

      // 3. INITIAL LOAD HANDLING
      const currentHash = window.location.hash.replace('#/', '').replace('#', '');
      if (currentHash) {
        switchTab(currentHash, false);
      } else {
        const defaultUrl = links[0].getAttribute('data-url') || links[0].getAttribute('href').replace('#', '');
        switchTab(defaultUrl, false);
      }
    });
  };

  initTabs();
  // Ensure it works in the Shopify Theme Editor
  document.addEventListener('shopify:section:load', initTabs);
})();
